module.exports = __webpack_public_path__ + "static/img/solutionDetailPic20.5ceaf22.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic20.jpg
// module id = gj/8
// module chunks = 1